<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	interface Props {
		label?: string | undefined;
		checked?: boolean;
	}

	let { label = undefined, checked = $bindable(false) }: Props = $props();
</script>

<label class="form-control">
	<input type="checkbox" bind:checked onchange={() => dispatch('change', { checked: !checked })} />

	{#if label}
		{label}
	{/if}
</label>

<style lang="postcss">
	@reference '../../../app.css';

	.form-control {
		@apply grid cursor-pointer grid-cols-[1em_auto] gap-3 leading-5;
	}

	input[type='checkbox'] {
		@apply m-0 grid cursor-pointer appearance-none place-content-center bg-[#fff];

		width: 1.15em;
		height: 1.15em;
		border: 0.15em solid #007dcb;
		border-radius: 0.15em;
		transform: translateY(-0.075em);

		&:before {
			@apply h-2 w-2;
			content: '';
			transform: scale(0);
			transition: transform 0.1s ease-in-out;
			box-shadow: inset 1em 1em #fff;
			transform-origin: bottom left;
			clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
		}

		&:checked {
			@apply bg-[#007dcb];

			&:before {
				transform: scale(1);
			}
		}
	}
</style>
